var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    ref: "overlay",
    staticClass: "Polaris-PositionedOverlay",
    style: (_vm.containerStyle)
  }, [_vm._t("overlay", null, {
    measuring: _vm.measuring,
    left: _vm.left,
    desiredHeight: _vm.height,
    positioning: _vm.positioning,
    tipPosition: _vm.tipPosition
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-567fd64e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567fd64e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPositionedOverlay.vue
// module id = 203
// module chunks = 0